import { Component, inject, OnInit, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { DealsApiService } from '@/pages/deals/data-access/deals-api.service';
import { AiSummaryCardComponent } from '@/shared/components/ai-summary-card/ai-summary-card.component';
import { AsyncState } from '@/shared/models/async-state.model';
import { AiSummaryDto } from '@/shared/models/ai-summary.model';

@Component({
    selector: 'app-c-ai-summary',
    standalone: true,
    imports: [AiSummaryCardComponent],
    template: `<app-ai-summary-card [state]="summaryState()" />`
})
export class CAiSummaryComponent implements OnInit {
    public readonly summaryState = signal<AsyncState<AiSummaryDto>>({ data: null, loading: false, error: null });

    private readonly _dealsApiService = inject(DealsApiService);

    public ngOnInit(): void {
        this.loadSummary();
    }

    private loadSummary(): void {
        this.summaryState.update((state) => ({ ...state, loading: true, error: null }));
        this._dealsApiService
            .getClientDealsAiSummary()
            .pipe(finalize(() => this.summaryState.update((state) => ({ ...state, loading: false }))))
            .subscribe({
                next: (data) => this.summaryState.set({ data, loading: false, error: null }),
                error: (err: unknown) => this.summaryState.set({ data: null, loading: false, error: err })
            });
    }
}
